// Il focus dopo un salvataggio della Timeline (piano M2 Task 19): la risposta del server arriva quando vuole, e intanto la
// persona può essere già andata a scrivere altrove (un dato della scheda, un'altra nota). Il focus torna nel riquadro
// soltanto se lei non si è spostata, come la casella della scheda con un rifiuto che arriva tardi (`FieldEditor`).

/**
 * Se la persona non ha spostato il focus altrove: non sta su nulla (la pagina, anche perché l'elemento che lo aveva è
 * sparito) oppure sta dentro `area`.
 */
export function focusStayedIn(area: Element | null): boolean {
  const active = document.activeElement;
  return active === null || active === document.body || (area !== null && area.contains(active));
}

/** I tipi di elemento della Timeline a cui un link porta: la telefonata, la nota, il salvataggio, l'evento e il WhatsApp. */
export type TimelineAnchorKind = "call" | "note" | "change" | "event" | "whatsapp";

/** L'`id` di un elemento della Timeline, a cui portano «Vedi nella Timeline» (la telefonata) e i link di «Attività» (SEZ-8). */
export function timelineAnchorId(kind: TimelineAnchorKind, id: string): string {
  return `timeline-${kind}-${id}`;
}

/** L'`id` della telefonata nella Timeline, a cui porta «Vedi nella Timeline» della sezione della sequenza (piano M5, Task 12). */
export function callAnchorId(callId: string): string {
  return timelineAnchorId("call", callId);
}
